import axios from "axios";
import { BASE_URL_MIDDLEWARE } from "../constants/config";
import type {
  Collection,
  ValidationFormValues,
  SubcriptionPayload,
} from "../types/form.types";

type ResponseData = {
  data: Collection[];
};

const api = axios.create({
  baseURL: BASE_URL_MIDDLEWARE,
});

export const getDocumentTypes = async () => {
  return (await api.get<ResponseData>("/api/document-types")).data.data;
};

export const getHobbies = async () => {
  return (await api.get<ResponseData>("/api/hobbies")).data.data;
};

export const getProvinces = async () => {
  return (await api.get<ResponseData>("/api/departments")).data.data;
};

export const getCities = async (id: number) => {
  return (await api.get<ResponseData>(`/api/cities/department/${id}`)).data
    .data;
};

export const validateUserAgreement = async (payload: ValidationFormValues) => {
  return await api.post("/api/validate-user", payload);
};

export const registerUser = async (payload: SubcriptionPayload) => {
  return await api.post("/api/register", payload);
};
